import { Box, CircularProgress } from "@mui/material";
import clsx from "clsx";
import type React from "react";

import { useLoadingStyles } from "./Loading.styles";

interface LoadingProps {
    size?: number;
    color?: "primary" | "onPrimary";
}

export const Loading: React.FC<LoadingProps> = ({ size = 20, color = "primary" }): JSX.Element => {
    const classes = useLoadingStyles();
    const colorClass = clsx({
        [classes.primary]: color === "primary",
        [classes.onPrimary]: color === "onPrimary",
    });

    return (
        <Box display="flex" justifyContent="center" alignItems="center">
            <CircularProgress size={size} className={colorClass} />
        </Box>
    );
};
